export default __webpack_public_path__ + "static/media/portis.1dd92809.svg";